export default {
    base: {
        state: 'declaration.incomeTax.creatIncomeTax',
        config: {
            url: '/creatIncomeTax',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'declaration.incomeTax.creatIncomeTax.list',
            title: '申报表生成',
        },
    },
    list: {
        state: 'declaration.incomeTax.creatIncomeTax.list',
        config: {
            url: '/list',
            template: require('./view/creatIncomeTax.html'),
            controller: 'creatIncomeTaxCtrl',

        },
    },
}



// WEBPACK FOOTER //
// ./src/app/declaration/incomeTax/creatIncomeTax/routers.js